import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import { useState } from "react";
import { AccountReportDto, ReportFilterArgumentsInput } from "../../../api/psc";
import { AppDatePicker, MultiSelect } from "../../../components/exports";

// updated
export default function ReportFilter(props: {
    report: AccountReportDto;
    isFetching: boolean;
    applyFilter: (GenerateReportInput) => void;
}) {
    const [from, setFrom] = useState<string | null>(null);

    const [to, setTo] = useState<string | null>(null);

    const initialValue = [
        ...props.report.filters.map((f, i) => {
            return { index: i, arguments: [] };
        }),
    ];

    const [filterArguments, setFilterArguments] =
        useState<ReportFilterArgumentsInput[]>(initialValue);

    const handleFromChange = (date: string) => {
        setFrom(date);
    };

    const handleToChange = (date: string) => {
        setTo(date);
    };

    const handleArgumentValuesChange = (
        index: number,
        values: (number | string)[]
    ) => {
        let argument = filterArguments.find((a) => a.index === index);
        let updatedArgument = {
            ...argument,
            arguments: values.map((v) => v.toString()),
        };
        const updatedArguments = [...filterArguments];
        updatedArguments[index] = updatedArgument;
        setFilterArguments(updatedArguments);
    };

    const applyFilter = () => {
        props.applyFilter({
            from: from,
            to: to,
            filterArguments: filterArguments,
        });
    };

    return (
        <Box sx={{ minWidth: 250 }}>
            <Box sx={{ mb: 2 }}>
                <AppDatePicker
                    label="تاریخ از"
                    onChange={handleFromChange}
                    initialValue={from}
                />
            </Box>

            <Box sx={{ mb: 2 }}>
                <AppDatePicker
                    label="تاریخ تا"
                    onChange={handleToChange}
                    initialValue={to}
                />
            </Box>

            {props.report.filters.map((f, i) => {
                return (
                    <Box key={i} sx={{ mb: 2 }}>
                        <MultiSelect
                            label={f.title}
                            values={f.items}
                            selectedIds={filterArguments[i].arguments.map((i) =>
                                parseInt(i)
                            )}
                            onValueChange={(values) =>
                                handleArgumentValuesChange(i, values)
                            }
                        />
                    </Box>
                );
            })}

            <LoadingButton
                fullWidth
                variant="contained"
                color="primary"
                loading={props.isFetching}
                onClick={applyFilter}
            >
                اعمال فیلتر
            </LoadingButton>
        </Box>
    );
}
